import isRunningOnClient from '@creuna/utils/is-running-on-client';

export const getNumericCssPropertyValue = propName => {
  if (!isRunningOnClient) return 0;

  return parseInt(
    getComputedStyle(document.documentElement).getPropertyValue(propName)
  );
};
